<div class="flex items-center justify-start w-full mt-4">
  <input
    type="button"
    class="secondary gap-4 border-2 font-semibold h-14 w-36 uppercase mr-2.5 cursor-pointer"
    [value]="literalService.get(cancelLabel(), true)"
    (click)="cancelAction.emit($event)"
  />
  <input
    type="button"
    class="primary text-white gap-4 border-2 font-semibold h-14 w-36 uppercase cursor-pointer"
    [value]="literalService.get(saveLabel(), true)"
    [disabled]="saveDisabled()"
    (click)="saveAction.emit($event)"
  />
</div>
